import { Card, Form, Select, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import { columnChartConfigurationOptions } from "../../config";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { formatDate } from "../../services/util";
const { Option } = Select;

function CheckInAnalytics() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    // selection settings
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const defaultFormData = {
        staff_id,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        all_selected: true,
        hotel_ids: [],
    };

    const [hotelOptions, setHotelOptions] = useState([]);
    const [formDataTimeZone, setFormDataTimeZone] = useState(defaultFormData);
    const [timeZoneChartData, setTimeZoneChartData] = useState([]);
    const [formDataShift, setFormDataShift] = useState(defaultFormData);
    const [shiftChartData, setShiftChartData] = useState([]);

    const {
        status: checkInByTimeZoneStatus,
        data: checkInByTimeZoneRes,
        refetch: getCheckInByTimeZone,
    } = useQuery(
        "checkInsByTimeZone",
        async () => {
            return await HTTP("/analytics/getAvgCheckinsTimezoneWise", {
                ...formDataTimeZone,
            });
        },
        { enabled: false },
    );

    const {
        status: checkInByShiftStatus,
        data: checkInByShiftRes,
        refetch: getCheckInByShift,
    } = useQuery(
        "checkInsByShift",
        async () => {
            return await HTTP("/analytics/getAvgCheckinsShiftWise", {
                ...formDataShift,
            });
        },
        { enabled: false },
    );

    const {
        status: hotelStatus,
        data: hotelData,
        refetch: getHotelSelectionOptions,
    } = useQuery(
        "analytics-hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", {
                staff_id,
                hotel_type: "all",
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getHotelSelectionOptions();
        getCheckInByTimeZone();
        getCheckInByShift();
    }, []);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormDataTimeZone({
            ...formDataTimeZone,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
        setFormDataShift({
            ...formDataShift,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        if (checkInByTimeZoneStatus === "success") {
            setTimeZoneChartData(checkInByTimeZoneRes.data);
        }
    }, [checkInByTimeZoneStatus, checkInByTimeZoneRes]);

    useEffect(() => {
        if (checkInByShiftStatus === "success") {
            const { data: chartData, success } = checkInByShiftRes;
            let data = [];
            if (success) {
                data = chartData.map((e, index) => {
                    if (index > 0) {
                        e[1] = parseFloat(e[1]);
                    }
                    return e;
                });
            }
            setShiftChartData(data);
        }
    }, [checkInByShiftRes, checkInByShiftStatus]);

    useEffect(() => {
        if (hotelStatus === "success") {
            setHotelOptions(hotelData.data);
        }
    }, [hotelStatus, hotelData]);

    useEffect(() => {
        getCheckInByTimeZone();
    }, [formDataTimeZone]);

    useEffect(() => {
        getCheckInByShift();
    }, [formDataShift]);

    function handleHotelSelectionTimeZone(e) {
        setFormDataTimeZone({
            ...formDataTimeZone,
            hotel_ids: e,
            all_selected: e.length > 0 ? false : true,
        });
    }

    function handleHotelSelectionShift(e) {
        setFormDataShift({
            ...formDataTimeZone,
            hotel_ids: e,
            all_selected: e.length > 0 ? false : true,
        });
    }

    return (
        <Card className="chartCard">
            <Form
                labelCol={{
                    span: 4,
                }}
                wrapperCol={{
                    span: 6,
                }}
            >
                <Form.Item label="Hotels" name="hotel_id">
                    <Select
                        id="hotel_id"
                        placeholder="Hotel Name"
                        className="jira-dashboard-select"
                        showSearch
                        mode="multiple"
                        onChange={handleHotelSelectionTimeZone}
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        loading={hotelOptions.length == 0}
                    >
                        {hotelOptions.map((h) => (
                            <Option
                                key={h.hotel_id || h.id}
                                value={h.hotel_id || h.id}
                            >
                                {`${h.hotel_id || h.id} - ${
                                    h.hotel_name || h.name
                                } - ${h.city}`}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
            {timeZoneChartData.length > 0 ? (
                <Chart
                    className="charts"
                    chartType="ColumnChart"
                    data={timeZoneChartData}
                    options={{
                        ...columnChartConfigurationOptions,
                        chartArea: {
                            ...columnChartConfigurationOptions.chartArea,
                        },
                        hAxis: {
                            minValue: 0,
                        },
                    }}
                />
            ) : (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 20, width: 40 }}
                />
            )}
            <Form
                labelCol={{
                    span: 4,
                }}
                wrapperCol={{
                    span: 6,
                }}
            >
                <Form.Item label="Hotels" name="hotel_id">
                    <Select
                        id="hotel_id"
                        placeholder="Hotel Name"
                        className="jira-dashboard-select"
                        showSearch
                        mode="multiple"
                        onChange={handleHotelSelectionShift}
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        loading={hotelOptions.length == 0}
                    >
                        {hotelOptions.map((h) => (
                            <Option
                                key={h.hotel_id || h.id}
                                value={h.hotel_id || h.id}
                            >
                                {`${h.hotel_id || h.id}-${
                                    h.hotel_name || h.name
                                } - ${h.city}`}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
            {shiftChartData.length > 0 ? (
                <Chart
                    className="charts"
                    chartType="ColumnChart"
                    data={shiftChartData}
                    options={{
                        ...columnChartConfigurationOptions,
                        chartArea: {
                            ...columnChartConfigurationOptions.chartArea,
                        },
                        hAxis: {
                            minValue: 0,
                        },
                    }}
                />
            ) : (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 20, width: 40 }}
                />
            )}
        </Card>
    );
}

export { CheckInAnalytics };
